
export const niveis_servicos = {
  elevado: {
    descricao: "Nível elevado",
    cor: "#FD0001",
    detalhes: "A falta deste item afetará significativamente os resultados"
  },
  alto: {
    descricao: "Nível alto",
    cor: "#FFBF05",
    detalhes: "A falta deste item afetará parte dos resultados"
  },
  medio: {
    descricao: "Nível médio",
    cor: "#FFFE02",
    detalhes: "A falta deste item poderá afetar os resultados"
  },
  baixo:  {
    descricao: "Nível baixo",
    cor: "#00AE51",
    detalhes:
      "A falta deste item não afetará de forma relevante os resultados"
  },
  ordinario: {
    descricao: "Nível ordinário",
    cor: "#0071C1",
    detalhes:
      "A falta deste item não afetará de forma relevante os resultados"
  },
  sob_encomenda: {
    descricao: "Sob encomenda",
    cor: "#0D0D0D",
    detalhes:
      "Item com perfil estratégico, sua compra deverá ser avaliada apenas quando demandadas pelas Unidades demandadoras, não entrando em cálculo de ressuprimento"
  }
};
